<script>
import Hammer from 'hammerjs'
import axios from 'axios'
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    attachments: {
      type: Array,
      default: null,
    },
    attachmentId: {
      type: [Number, String],
      required: true,
    },
    resource: {
      type: String,
      required: false,
      default: null,
    },
    recipientid: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      currentSrc: this.src,
      currentType: this.type,
      currentTitle: this.title,
      currentAttachmentId: this.attachmentId,
      loading: false,
      zoomCount: 0,
      acceptedTypes: ['jpg', 'jpeg', 'png'],
      minScale: 1,
      maxScale: 4,
      imageWidth: undefined,
      imageHeight: undefined,
      containerWidth: undefined,
      containerHeight: undefined,
      displayImageX: 0,
      displayImageY: 0,
      displayImageScale: 1,

      displayDefaultWidth: undefined,
      displayDefaultHeight: undefined,

      rangeX: 0,
      rangeMaxX: 0,
      rangeMinX: 0,

      rangeY: 0,
      rangeMaxY: 0,
      rangeMinY: 0,

      displayImageRangeY: 0,

      displayImageCurrentX: 0,
      displayImageCurrentY: 0,
      displayImageCurrentScale: 1,
    }
  },
  computed: {
    previousUrl() {
      if (this.attachments) {
        for (let i = 0; i < this.attachments.length; i++) {
          if (i > 0 && this.attachments[i].id === this.currentAttachmentId) {
            let cnt = i - 1
            while (cnt >= 0) {
              if (
                this.acceptedTypes.includes(this.attachments[cnt].extension)
              ) {
                return cnt
              }
              cnt--
            }
          }
        }
      }

      return null
    },
    nextUrl() {
      if (this.attachments) {
        for (let i = 0; i < this.attachments.length; i++) {
          if (
            i < this.attachments.length - 1 &&
            this.attachments[i].id === this.currentAttachmentId
          ) {
            let cnt = i + 1
            while (cnt < this.attachments.length) {
              if (
                this.acceptedTypes.includes(this.attachments[cnt].extension)
              ) {
                return cnt
              }
              cnt++
            }
          }
        }
      }

      return null
    },
  },
  async mounted() {
    const imageContainer = document.querySelector('#imageContainer')
    this.loading = true
    await this.setImage()
    this.resizeContainer()
    this.loading = false
    window.addEventListener('resize', this.resizeContainer, true)
    const hammerTime = new Hammer(imageContainer)
    hammerTime.get('pinch').set({ enable: true })
    hammerTime.get('pan').set({ direction: Hammer.DIRECTION_ALL })

    hammerTime.on('pan', (ev) => {
      this.displayImageCurrentX = this.clamp(
        this.displayImageX + ev.deltaX,
        this.rangeMinX,
        this.rangeMaxX
      )
      this.displayImageCurrentY = this.clamp(
        this.displayImageY + ev.deltaY,
        this.rangeMinY,
        this.rangeMaxY
      )
      this.updateDisplayImage(
        this.displayImageCurrentX,
        this.displayImageCurrentY,
        this.displayImageScale
      )
    })

    hammerTime.on('pinch pinchmove', (ev) => {
      this.displayImageCurrentScale = this.clampScale(
        ev.scale * this.displayImageScale
      )
      this.updateRange()
      this.displayImageCurrentX = this.clamp(
        this.displayImageX + ev.deltaX,
        this.rangeMinX,
        this.rangeMaxX
      )
      this.displayImageCurrentY = this.clamp(
        this.displayImageY + ev.deltaY,
        this.rangeMinY,
        this.rangeMaxY
      )
      this.updateDisplayImage(
        this.displayImageCurrentX,
        this.displayImageCurrentY,
        this.displayImageCurrentScale
      )
    })

    hammerTime.on('panend pancancel pinchend pinchcancel', () => {
      this.displayImageScale = this.displayImageCurrentScale
      this.displayImageX = this.displayImageCurrentX
      this.displayImageY = this.displayImageCurrentY
    })
  },
  destroyed: function() {
    window.removeEventListener('resize', this.resizeContainer)
  },
  methods: {
    closeOverlay() {
      this.$emit('closeOverlay')
    },
    resetData() {
      this.imageWidth = undefined
      this.imageHeight = undefined
      this.containerWidth = undefined
      this.containerHeight = undefined
      this.displayImageX = 0
      this.displayImageY = 0
      this.displayImageScale = 1

      this.displayDefaultWidth = undefined
      this.displayDefaultHeight = undefined

      this.rangeX = 0
      this.rangeMaxX = 0
      this.rangeMinX = 0

      this.rangeY = 0
      this.rangeMaxY = 0
      this.rangeMinY = 0

      this.displayImageRangeY = 0

      this.displayImageCurrentX = 0
      this.displayImageCurrentY = 0
      this.displayImageCurrentScale = 1
    },
    async setImage() {
      const imageContainer = document.querySelector('#imageContainer')
      const self = this
      const displayImage = new Image()
      displayImage.id = 'displayImage'
      let data
      if (this.resource === 'unauth') {
        data = await axios.post(`/api/v1/library/shared/hr/files/`, {
          file_id: this.attachmentId,
          recipient_information_id: this.recipientid,
        })
      } else if (this.resource === 'vault') {
        // eslint-disable-next-line dot-notation
        data = {
          data: {
            url: this.src,
          },
        }
      } else {
        data = await axios.get(
          `/api/v1/library/files/${self.currentAttachmentId}`
        )
      }
      displayImage.src = data.data.url
      displayImage.onload = await function() {
        self.imageWidth = displayImage.width
        self.imageHeight = displayImage.height
        imageContainer.appendChild(displayImage)
        displayImage.addEventListener(
          'mousedown',
          (e) => e.preventDefault(),
          false
        )
        self.displayDefaultWidth = displayImage.offsetWidth
        self.displayDefaultHeight = displayImage.offsetHeight
        self.rangeX = Math.max(
          0,
          self.displayDefaultWidth - self.containerWidth
        )
        self.rangeY = Math.max(
          0,
          self.displayDefaultHeight - self.containerHeight
        )
      }
    },
    async redraw(loader = true) {
      const target = document.querySelector('#displayImage')
      if (target) {
        target.remove()
        this.resetData()
        if (loader) {
          this.loading = true
        }
        await this.setImage()
        this.resizeContainer()
        if (loader) {
          this.loading = false
        }
      }
    },
    async refreshItem(index) {
      this.currentSrc = this.attachments[index].url
      this.currentType = this.attachments[index].extension
      this.currentTitle = this.attachments[index].name
      this.currentAttachmentId = this.attachments[index].id
      await this.redraw()
      this.zoomCount = 0
    },
    async defaultSize() {
      await this.redraw(false)
      this.zoomCount = 0
    },
    async download() {
      try {
        let data
        if (this.resource === 'unauth') {
          data = await axios.post(`/api/v1/library/shared/hr/files/`, {
            file_id: this.attachmentId,
            record_id: this.attachments[0].record.id,
          })
        } else if (this.resource === 'vault') {
          // eslint-disable-next-line dot-notation
          data = {
            data: {
              url: this.src,
            },
          }
        } else {
          data = await axios.get(
            `/api/v1/library/files/${this.currentAttachmentId}`
          )
        }
        const res = await fetch(data.data.url)
        const blob = await res.blob()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'export'
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (error) {
        console.warn(error)
      }
    },
    getMaximum(value, type) {
      if (value < 100) {
        return 50
      } else if (value > 100 && value < 300) {
        return 180
      } else {
        if (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) {
          return 300
        } else {
          if (type === 'width') {
            return 800
          } else {
            return 650
          }
        }
      }
    },
    zoomIn() {
      this.wheel(null, 120)
    },
    zoomOut() {
      this.wheel(null, -120)
    },
    showPlusSign() {
      return this.zoomCount > 0
    },
    clamp(value, min, max) {
      return Math.min(Math.max(min, value), max)
    },

    clampScale(newScale) {
      return this.clamp(newScale, this.minScale, this.maxScale)
    },
    updateRange() {
      this.rangeX = Math.max(
        0,
        Math.round(this.displayDefaultWidth * this.displayImageCurrentScale) -
          this.containerWidth
      )
      this.rangeY = Math.max(
        0,
        Math.round(this.displayDefaultHeight * this.displayImageCurrentScale) -
          this.containerHeight
      )

      this.rangeMaxX = Math.round(this.rangeX / 2)
      this.rangeMinX = 0 - this.rangeMaxX

      this.rangeMaxY = Math.round(this.rangeY / 2)
      this.rangeMinY = 0 - this.rangeMaxY
    },
    updateDisplayImage(x, y, scale) {
      const displayImage = document.querySelector('#displayImage')
      const transform =
        'translateX(' +
        x +
        'px) translateY(' +
        y +
        'px) translateZ(0px) scale(' +
        scale +
        ',' +
        scale +
        ')'
      displayImage.style.transform = transform
      displayImage.style.WebkitTransform = transform
      displayImage.style.msTransform = transform
    },
    wheel(event, customDelta = null) {
      const delta = customDelta || event.wheelDelta
      if (this.zoomCount < 20 && delta > 0) {
        this.zoomCount++
      }
      if (this.zoomCount > 0 && delta < 0) {
        this.zoomCount--
      }

      this.displayImageScale = this.displayImageCurrentScale = this.clampScale(
        this.displayImageScale + delta / 800
      )
      this.updateRange()
      this.displayImageCurrentX = this.clamp(
        this.displayImageCurrentX,
        this.rangeMinX,
        this.rangeMaxX
      )
      this.displayImageCurrentY = this.clamp(
        this.displayImageCurrentY,
        this.rangeMinY,
        this.rangeMaxY
      )
      this.updateDisplayImage(
        this.displayImageCurrentX,
        this.displayImageCurrentY,
        this.displayImageScale
      )
    },
    resizeContainer() {
      const imageContainer = document.querySelector('#imageContainer')
      const displayImage = document.querySelector('#displayImage')
      this.containerWidth = imageContainer.offsetWidth
      this.containerHeight = imageContainer.offsetHeight
      if (
        this.displayDefaultWidth !== undefined &&
        this.displayDefaultHeight !== undefined
      ) {
        this.displayDefaultWidth = displayImage.offsetWidth
        this.displayDefaultHeight = displayImage.offsetHeight
        this.updateRange()
        this.displayImageCurrentX = this.clamp(
          this.displayImageX,
          this.rangeMinX,
          this.rangeMaxX
        )
        this.displayImageCurrentY = this.clamp(
          this.displayImageY,
          this.rangeMinY,
          this.rangeMaxY
        )
        this.updateDisplayImage(
          this.displayImageCurrentX,
          this.displayImageCurrentY,
          this.displayImageCurrentScale
        )
      }
    },
  },
}
</script>

<template>
  <v-card
    v-click-outside="closeOverlay"
    :class="$style.attachmentCard"
    width="100%"
  >
    <v-card-title>
      <v-toolbar flat>
        <v-toolbar-title>{{ currentTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="
            resource !== 'vault' &&
              resource !== 'unauth' &&
              currentType !== 'pdf'
          "
          text
          fab
          @click="download"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-btn text fab class="ml-2" @click="$emit('closeOverlay')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card-title>
    <v-row
      v-if="loading"
      no-gutters
      justify="center"
      align="center"
      :class="$style.loaderRow"
    >
      <v-progress-circular
        class="ml-2"
        size="30"
        width="2"
        color="white"
        indeterminate
      ></v-progress-circular>
    </v-row>
    <v-card-text v-show="!loading" class="mt-2">
      <v-row class="justify-space-between align-center">
        <v-icon
          :disabled="previousUrl === null"
          :class="$style.iconZIndex"
          @click="refreshItem(previousUrl)"
          >mdi-chevron-left</v-icon
        >
        <v-row
          :class="$style.attachmentRow"
          no-gutters
          class="justify-center align-center"
        >
          <div
            id="imageContainer"
            :class="$style.imageContainer"
            @wheel="wheel"
          >
          </div>
        </v-row>

        <v-icon :disabled="nextUrl === null" @click="refreshItem(nextUrl)"
          >mdi-chevron-right</v-icon
        >
      </v-row>
      <v-container v-if="!loading" class="mt-4">
        <v-row justify="center">
          <v-btn text fab :disabled="zoomCount <= 0" @click="zoomOut">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-btn text fab :disabled="zoomCount <= 0" @click="defaultSize">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
          <v-btn text fab :disabled="zoomCount >= 20" @click="zoomIn">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
.attachmentCard {
  opacity: 0.98;
}
.attachmentRow {
  max-width: 80vw;
  height: 700px !important;
  overflow: hidden !important;
}
.attachmentRowPdf {
  height: 700px !important;
}
.imageContainer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 96%;
  max-width: 800px;
  height: 96%;
  max-height: 650px;
  margin: auto;
  overflow: hidden;
}

.imageContainer > img {
  display: block;
  width: 80%;
  height: 80%;
  object-fit: scale-down;
  touch-action: none;
  cursor: move;
}

.loaderRow {
  height: 700px !important;
  overflow: hidden !important;
}

.iconZIndex {
  z-index: 5;
}
</style>
